import Vue from "vue";
import store from "../store/index";
import VueRouter from "vue-router";

import {
	MessageBox
} from "element-ui";

Vue.use(VueRouter);

// 解决报错
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
	return originalReplace.call(this, location).catch((err) => err);
};
// 全部路由跳转页面
const index_home = () => import("@/views/index.vue");
const agreement = () => import("@/views/agreement.vue");
//首页模块
//首页
const home = () => import("@/views/index_tab/home.vue");
//首页的律师入驻
const lawyer_add = () => import("@/views/index_tab/lawyer_add.vue");
//首页的律所入住
const law_firms_add = () => import("@/views/index_tab/law_firms_add.vue");
// 律师律所入住申请成功
const end_success = () => import("@/views/index_tab/end_success.vue");

//法律咨询模块
//在线咨询
const online = () => import("@/views/legal_advice/online.vue");
//在线咨询上班
const online_work = () => import("@/views/legal_advice/online_work.vue");
//在线咨询下班
const online_quitting = () => import("@/views/legal_advice/online_quitting.vue");
//咨询申请成功
const online_success= () => import("@/views/legal_advice/online_success.vue");
//咨询支付
const online_pay= () => import("@/views/legal_advice/online_pay.vue");

//诉讼类
const lawsuit_index = () => import("@/views/legal_advice/lawsuit/lawsuit_index.vue");
//非诉讼
const no_lawsuit_index = () => import("@/views/legal_advice/no_lawsuit/no_lawsuit_index.vue");

//律师列表
const lawyer_list = () => import("@/views/legal_advice/lawyer_list/lawyer_list.vue");
//律师详情
const lawyer_detial = () => import("@/views/legal_advice/lawyer_list/lawyer_detial.vue");
//律师服务
const lawyer_sever_list = () => import("@/views/legal_advice/lawyer_list/lawyer_sever_list.vue");


//裁判点评模块
//裁判点评
const comments_list = () => import("@/views/comments_case/comments/comments_list.vue");
//点评详情
const comments_detial = () => import("@/views/comments_case/comments/comments_detial.vue");
//案例发布模块
//案例发布首页
const release_index = () => import("@/views/comments_case/case_add/release_index.vue");
//案例发布添加
const release_add = () => import("@/views/comments_case/case_add/release_add.vue");
//案例发布支付
const release_pay = () => import("@/views/comments_case/case_add/release_pay.vue");
//案例发布支付成功
const release_success = () => import("@/views/comments_case/case_add/release_success.vue");

//案例库模块
//案例列表
const case_list = () => import("@/views/comments_case/case_list/case_list.vue");
//案例详情
const case_detial = () => import("@/views/comments_case/case_list/case_detial.vue");
//案例查看支付
const case_pay = () => import("@/views/comments_case/case_list/case_pay.vue");
//案例查看支付成功
const case_success = () => import("@/views/comments_case/case_list/case_success.vue");

 
//案例广场 模块
// 列表
const square_list = () => import("@/views/case_source_square/square_list.vue");
// 详情
const square_detial = () => import("@/views/case_source_square/square_detial.vue");





//法务委托 模块
//企业法务enterprise
//企业法务列表
const enterprise_list = () => import("@/views/Legal/enterprise/enterprise_list.vue");
//企业法务详情
const enterprise_detial = () => import("@/views/Legal/enterprise/enterprise_detial.vue");

//个人法务 individual
//个人法务列表
const individual_list = () => import("@/views/Legal/individual/individual_list.vue");
//个人法务详情
const individual_detial = () => import("@/views/Legal/individual/individual_detial.vue");


//法务委托提交页面
const legal_lawyer_index = () => import("@/views/Legal/legal_lawyer_index.vue");
const no_legal_lawyer_index = () => import("@/views/Legal/no_legal_lawyer_index.vue");
const Legal_pay = () => import("@/views/Legal/Legal_pay.vue");
const Legal_success = () => import("@/views/Legal/Legal_success.vue");


//法律讲堂
//法律讲堂首页
const Classroom = () => import("@/views/Law/Classroom/Classroom.vue");
//法律讲堂列表 文字版本
const Classroom_list_text = () => import("@/views/Law/Classroom/Classroom_list_text.vue");
// 详情
const Classroom_list_text_detial = () => import("@/views/Law/Classroom/Classroom_list_text_detial.vue");




//法律讲堂列表 视频版本
const Classroom_list_video = () => import("@/views/Law/Classroom/Classroom_list_video.vue");
// 详情
const Classroom_list_video_detial = () => import("@/views/Law/Classroom/Classroom_list_video_detial.vue");


//课堂的统一支付
const Classroom_pay = () => import("@/views/Law/Classroom/Classroom_pay.vue");
//课堂的统一支付成功
const Classroom_success = () => import("@/views/Law/Classroom/Classroom_success.vue");
// const Classroom_success = () => import("@/views/Law/Classroom/Classroom_success.vue");



//法界热点hot spot
const hot_spot = () => import("@/views/Law/hot_spot/hot_spot.vue");
//法界热点分类
const hot_spot_type = () => import("@/views/Law/hot_spot/hot_spot_type.vue");
//法界热点详情
const hot_spot_type_detial = () => import("@/views/Law/hot_spot/hot_spot_type_detial.vue");

// 人才招聘 talent acquisition
// 人才招聘 列表
const talent_acquisition = () => import("@/views/Law/talent_acquisition/talent_acquisition.vue");
// 人才招聘 详情
const talent_acquisition_detial = () => import("@/views/Law/talent_acquisition/talent_acquisition_detial.vue");



//招商加盟 Merchants to join
//招商加盟 Merchants
const Merchants = () => import("@/views/Merchants/Merchants_join/Merchants.vue");


//区域合伙人 Regional_Partner
const Regional_Partner = () => import("@/views/Merchants/Regional_Partner/Regional_Partner.vue");


//更多服务 More services
const service = () => import("@/views/More_services/service/service.vue");
const shop = () => import("@/views/More_services/shop/shop.vue");
const shop_detial = () => import("@/views/More_services/shop/shop_detial.vue");



// 登录注册模块
// 登录
const login = () => import("@/views/login/login.vue");
//注册
const enroll = () => import("@/views/login/enroll.vue");
//忘记密码
const password = () => import("@/views/login/password.vue");
//完善信息
const login_info= () => import("@/views/login/login_info.vue");
//完善信息完成
const login_info_end= () => import("@/views/login/login_info_end.vue");


//个人中心模块
//个人中心主页跳转页面
const user_index= () => import("@/views/user_info/user_index.vue");
const user_grzx= () => import("@/views/user_info/users/user_grzx/user_grzx.vue");
//律师的个人中心
const user_grzx_ls= () => import("@/views/user_info/users/user_grzx/user_grzx_ls.vue");

//我的订单
const user_order= () => import("@/views/user_info/users/user_order/user_order.vue");
const order_detial= () => import("@/views/user_info/users/user_order/order_detial.vue");
const order_pj= () => import("@/views/user_info/users/user_order/order_pj.vue");


// 我的点评
const user_dp= () => import("@/views/user_info/users/user_dp/user_dp.vue");
const user_dp_detial= () => import("@/views/user_info/users/user_dp/user_dp_detial.vue");
const user_dp_pj= () => import("@/views/user_info/users/user_dp/user_dp_pj.vue");
// 我的委托
const user_wt= () => import("@/views/user_info/users/user_wt/user_wt.vue");
const user_wt_detial= () => import("@/views/user_info/users/user_wt/user_wt_detial.vue");

//点评服务
const user_dpfw= () => import("@/views/user_info/users/user_dpfw/user_dpfw.vue");
//点评服务详情
const user_dpfw_detial= () => import("@/views/user_info/users/user_dpfw/user_dpfw_detial.vue");
//点评服务点评
const user_dpfw_add= () => import("@/views/user_info/users/user_dpfw/user_dpfw_add.vue");


//委托服务
const user_wtfw= () => import("@/views/user_info/users/user_wtfw/user_wtfw.vue");
const user_wtfw_detial= () => import("@/views/user_info/users/user_wtfw/user_wtfw_detial.vue");

// 我的消息
const user_xx= () => import("@/views/user_info/users/user_xx/user_xx.vue");
// 我的咨询
const user_zx= () => import("@/views/user_info/users/user_zx/user_zx.vue");
const user_zx_detial= () => import("@/views/user_info/users/user_zx/user_zx_detial.vue");
// 我的积分
const user_jf= () => import("@/views/user_info/users/user_jf/user_jf.vue");
// 积分商城
const user_jfsc= () => import("@/views/user_info/users/user_jfsc/user_jfsc.vue");
// 我的佣金
const user_jl= () => import("@/views/user_info/users/user_jl/user_jl.vue");
const family_list= () => import("@/views/user_info/users/user_jl/family_list.vue");
const share= () => import("@/views/user_info/users/user_jl/share.vue");
const payouts= () => import("@/views/user_info/users/user_jl/payouts.vue");


// 抽奖活动
const user_cjhd= () => import("@/views/user_info/users/user_cjhd/user_cjhd.vue");
//财务管理
const user_cwgl= () => import("@/views/user_info/users/user_cwgl/user_cwgl.vue");

// 个人资料
const user_zl= () => import("@/views/user_info/users/user_zl/user_zl.vue");
// 修改密码
const user_mm= () => import("@/views/user_info/users/user_mm/user_mm.vue");
// 发票管理
const user_gl= () => import("@/views/user_info/users/user_gl/user_gl.vue");
const user_gl_detial= () => import("@/views/user_info/users/user_gl/user_gl_detial.vue");
// 帮助中心
const user_bzzx= () => import("@/views/user_info/users/user_bzzx/user_bzzx.vue");




 


const routes = [
	


	{
		path: "/",
		name: "index_home",
		component: index_home,
		redirect: "/home",
		// redirect: "/user_index",
		
		meta: {
			title: "路由包含页面",
			keepAlive: false,
		},
		children: [
			//首页模块
			{
				path: "/home",
				name: "home",
				component: home,
				meta: {
					title: "首页",
					is_login:false,
				},
			},
			{
				path: "/lawyer_add",
				name: "lawyer_add",
				component: lawyer_add,
				meta: {
					title: "律师入驻",
					is_login:false,
				},
			},
		
			{
				path: "/law_firms_add",
				name: "law_firms_add",
				component: law_firms_add,
				meta: {
					title: "律所入驻",
					is_login:false,
				},
			},
			{
				path: "/end_success",
				name: "end_success",
				component: end_success,
				meta: {
					title: "律师律所入驻申请成功",
					is_login:false,
				},
			},
			//法律咨询模块

			{
				path: "/online",
				name: "online",
				component: online,
				meta: {
					title: "在线咨询",
					is_login:false,
				},
			},
			{
				path: "/online_work",
				name: "online_work",
				component: online_work,
				meta: {
					title: "在线咨询",//上班
					is_login:false,
				},
			},
			{
				path: "/online_quitting",
				name: "online_quitting",
				component: online_quitting,
				meta: {
					title: "在线咨询",//下班
					is_login:false,
				},
			},
			{
				path: "/online_pay",
				name: "online_pay",
				component: online_pay,
				meta: {
					title: "咨询支付",//咨询成功 
					is_login:false,
				},
			},
			{
				path: "/online_success",
				name: "online_success",
				component: online_success,
				meta: {
					title: "咨询申请成功",//申请成功 
					is_login:false,
				},
			},
			
			{
				path: "/lawsuit_index",
				name: "lawsuit_index",
				component: lawsuit_index,
				meta: {
					title: "在线咨询",//诉讼类
					is_login:false,
				},
			},
			{
				path: "/no_lawsuit_index",
				name: "no_lawsuit_index",
				component: no_lawsuit_index,
				meta: {
					title: "在线咨询",//诉讼类
					is_login:false,
				},
			},
			{
				path: "/lawyer_list",
				name: "lawyer_list",
				component: lawyer_list,
				meta: {
					title: "在线委托",//律师列表
					is_login:false,
				},
			},
			{
				path: "/lawyer_detial",
				name: "lawyer_detial",
				component: lawyer_detial,
				meta: {
					title: "律师详情",//律师列表
					is_login:false,
				},
			},
			{
				path: "/lawyer_sever_list",
				name: "lawyer_sever_list",
				component: lawyer_sever_list,
				meta: {
					title: "律师服务",//律师列表
					is_login:false,
				},
			},

			

			//裁判点评模块
			//裁判点评
			{
				path: "/comments_list",
				name: "comments_list",
				component: comments_list,
				meta: {
					title: "裁判点评",//点评列表
					is_login:false,
				},
			},
			{
				path: "/comments_detial",
				name: "comments_detial",
				component: comments_detial,
				meta: {
					title: "裁判点评详情",//点评列表
					is_login:false,
				},
			},
			{
				path: "/release_index",
				name: "release_index",
				component: release_index,
				meta: {
					title: "案例发布",//案例发布首页
					is_login:false,
				},
			},

			{
				path: "/release_add",
				name: "release_add",
				component: release_add,
				meta: {
					title: "案例发布",//案例发布添加
					is_login:false,
				},
			},

			{
				path: "/release_pay",
				name: "release_pay",
				component: release_pay,
				meta: {
					title: "案例发布",//案例发布支付
					is_login:false,
				},
			},
			{
				path: "/release_success",
				name: "release_success",
				component: release_success,
				meta: {
					title: "案例发布",//案例发布支付成功
					is_login:false,
				},
			},
			
			// 案例库模块
			
			{
				path: "/case_list",
				name: "case_list",
				component: case_list,
				meta: {
					title: "案例库",//案例库列表
					is_login:false,
				},
			},

			{
				path: "/case_detial",
				name: "case_detial",
				component: case_detial,
				meta: {
					title: "案例库",//案例库详情
					is_login:false,
				},
			},
			{
				path: "/case_pay",
				name: "case_pay",
				component: case_pay,
				meta: {
					title: "案例库",//案例库支付
					is_login:false,
				},
			},
			{
				path: "/case_success",
				name: "case_success",
				component: case_success,
				meta: {
					title: "案例库",//案例库支付
					is_login:false,
				},
			},

			//案例广场模块
			
			{
				path: "/square_list",
				name: "square_list",
				component: square_list,
				meta: {
					title: "案例广场",//案例广场列表
					is_login:false,
				},
			},
			{
				path: "/square_detial",
				name: "square_detial",
				component: square_detial,
				meta: {
					title: "案例广场",//案例广场详情
					is_login:false,
				},
			},


			//法务模块
			
			//企业法务

			{
				path: "/enterprise_list",
				name: "enterprise_list",
				component: enterprise_list,
				meta: {
					title: "企业法务",//企业法务列表
					is_login:false,
				},
			},
			{
				path: "/enterprise_detial",
				name: "enterprise_detial",
				component: enterprise_detial,
				meta: {
					title: "企业法务",//企业法务详情
					is_login:false,
				},
			},

			//个人法务
			{
				path: "/individual_list",
				name: "individual_list",
				component: individual_list,
				meta: {
					title: "个人法务",//个人法务列表
					is_login:false,
				},
			},
			{
				path: "/individual_detial",
				name: "individual_detial",
				component: individual_detial,
				meta: {
					title: "个人法务",//个人法务详情
					is_login:false,
				},
			},
			{
				path: "/legal_lawyer_index",
				name: "legal_lawyer_index",
				component: legal_lawyer_index,
				meta: {
					title: "个人法务",//个人法务/企业法务 提交页面
					is_login:false,
				},
			},
			{
				path: "/no_legal_lawyer_index",
				name: "no_legal_lawyer_index",
				component: no_legal_lawyer_index,
				meta: {
					title: "个人法务",//个人法务/企业法务 提交页面
					is_login:false,
				},
			},
			{
				path: "/Legal_pay",
				name: "Legal_pay",
				component: Legal_pay,
				meta: {
					title: "个人法务",//个人法务/企业法务 支付页面
					is_login:false,
				},
			},
			{
				path: "/Legal_success",
				name: "Legal_success",
				component: Legal_success,
				meta: {
					title: "个人法务",//个人法务/企业法务 支付完成页面
					is_login:false,
				},
			},

			//法律讲堂模块

			{
				path: "/Classroom",
				name: "Classroom",
				component: Classroom,
				meta: {
					title: "法律讲堂",//法律讲堂首页
					is_login:false,
				},
			},
			{
				path: "/Classroom_list_text",
				name: "Classroom_list_text",
				component: Classroom_list_text,
				meta: {
					title: "法律讲堂",//法律讲堂列表 文字版本
					is_login:false,
				},
			},
			{
				path: "/Classroom_list_text_detial",
				name: "Classroom_list_text_detial",
				component: Classroom_list_text_detial,
				meta: {
					title: "法律讲堂",//法律讲堂详情 文字版本
					is_login:false,
				},
			},
			{
				path: "/Classroom_list_video",
				name: "Classroom_list_video",
				component: Classroom_list_video,
				meta: {
					title: "法律讲堂",//法律讲堂列表 视频版本
					is_login:false,
				},
			},
			{
				path: "/Classroom_list_video_detial",
				name: "Classroom_list_video_detial",
				component: Classroom_list_video_detial,
				meta: {
					title: "法律讲堂",//法律讲堂详情 视频版本
					is_login:false,
				},
			},
			
			{
				path: "/Classroom_pay",
				name: "Classroom_pay",
				component: Classroom_pay,
				meta: {
					title: "法律讲堂",//法律讲堂统一支付
					is_login:false,
				},
			},
			{
				path: "/Classroom_success",
				name: "Classroom_success",
				component: Classroom_success,
				meta: {
					title: "法律讲堂",//法律讲堂统一支付成功
					is_login:false,
				},
			},


			//法界热点模块
			
			{
				path: "/hot_spot",
				name: "hot_spot",
				component: hot_spot,
				meta: {
					title: "法界热点",//法界热点首页
					is_login:false,
				},
			},
			{
				path: "/hot_spot_type",
				name: "hot_spot_type",
				component: hot_spot_type,
				meta: {
					title: "法界热点",//法界热点分类详情
					is_login:false,
				},
			},

			{
				path: "/hot_spot_type_detial",
				name: "hot_spot_type_detial",
				component: hot_spot_type_detial,
				meta: {
					title: "法界热点",//法界热点详情
					is_login:false,
				},
			},
			{
				path: "/talent_acquisition",
				name: "talent_acquisition",
				component: talent_acquisition,
				meta: {
					title: "人才招聘",//人才招聘列表
					is_login:false,
				},
			},
			{
				path: "/talent_acquisition_detial",
				name: "talent_acquisition_detial",
				component: talent_acquisition_detial,
				meta: {
					title: "人才招聘",//人才招聘列表
					is_login:false,
				},
			},

			// 招商加盟
			{
				path: "/Merchants",
				name: "Merchants",
				component: Merchants,
				meta: {
					title: "招商加盟",//招商加盟
					is_login:false,
				},
			},

			{
				path: "/Regional_Partner",
				name: "Regional_Partner",
				component: Regional_Partner,
				meta: {
					title: "区域合伙人",//区域合伙人
					is_login:false,
				},
			},

			{
				path: "/service",
				name: "service",
				component: service,
				meta: {
					title: "更多服务",//更多服务
					is_login:false,
				},
			},
			{
				path: "/shop",
				name: "shop",
				component: shop,
				meta: {
					title: "积分商城",//更多服务
					is_login:false,
				},
			},

			{
				path: "/shop_detial",
				name: "shop_detial",
				component: shop_detial,
				meta: {
					title: "积分商城",//更多服务
					is_login:false,
				},
			},



			
			


			
			



			
			

			
			//登录注册模块
			{
				path: "/login",
				name: "login",
				component: login,
				meta: {
					title: "登录",
					is_login:false,

				},
			},
			{
				path: "/enroll",
				name: "enroll",
				component: enroll,
				meta: {
					title: "注册",
					is_login:false,

				},
			},
			{
				path: "/password",
				name: "password",
				component: password,
				meta: {
					title: "忘记密码",
					is_login:false,

				},
			},
			{
				path: "/login_info",
				name: "login_info",
				component: login_info,
				meta: {
					title: "完善信息",
					is_login:false,

				},
			},
			{
				path: "/login_info_end",
				name: "login_info_end",
				component: login_info_end,
				meta: {
					title: "完善信息",
					is_login:false,

				},
			},


			//个人中心模块
			{
				path: "/user_cjhd",
				name: "user_cjhd",
				component: user_cjhd,
				meta: {
					title: "抽奖活动",//单独的大页面  属于个人中心的抽奖
					is_login:true,

				},
			},
			{
				path: "/user_index",
				name: "user_index",
				component: user_index,
				redirect: "/user_grzx",

				meta: {
					title: "个人中心主页",
					is_login:true,
				},
				children:[
					{
						path: "/user_grzx",
						name: "user_grzx",
						component: user_grzx,
						meta: {
							title: "个人中心",
							is_login:true,
		
						},
					},
					{
						path: "/user_grzx_ls",
						name: "user_grzx_ls",
						component: user_grzx_ls,
						meta: {
							title: "个人中心",
							is_login:true,
		
						},
					},
					


					{
						path: "/user_order",
						name: "user_order",
						component: user_order,
						meta: {
							title: "我的订单",
							is_login:true,
		
						},
					},
					{
						path: "/user_order/order_detial",
						name: "user_order/order_detial",
						component: order_detial,
						meta: {
							title: "我的订单",
							is_login:true,
		
						},
					},
					{
						path: "/user_order/order_pj",
						name: "user_order/order_pj",
						component: order_pj,
						meta: {
							title: "我的订单",
							is_login:true,
		
						},
					},


					
					{
						path: "/user_dp",
						name: "user_dp",
						component: user_dp,
						meta: {
							title: "我的点评",
							is_login:true,
		
						},
					},
	
					{
						path: "/user_dp/user_dp_detial",
						name: "user_dp/user_dp_detial",
						component: user_dp_detial,
						meta: {
							title: "我的点评",//点评详情
							is_login:true,
		
						},
					},
					{
						path: "/user_dp/user_dp_pj",
						name: "user_dp/user_dp_pj",
						component: user_dp_pj,
						meta: {
							title: "我的点评",//点评详情
							is_login:true,
		
						},
					},
					
					
					{
						path: "/user_wt",
						name: "user_wt",
						component: user_wt,
						meta: {
							title: "我的委托",//我的委托列表
							is_login:true,
		
						},
					},
					{
						path: "/user_wt/user_wt_detial",
						name: "user_wt/user_wt_detial",
						component: user_wt_detial,
						meta: {
							title: "我的委托",//我的委托详情
							is_login:true,
		
						},
					},


					{
						path: "/user_dpfw",
						name: "user_dpfw",
						component: user_dpfw,
						meta: {
							title: "点评服务",//点评服务列表
							is_login:true,
		
						},
					},
					{
						path: "/user_dpfw/user_dpfw_detial",
						name: "user_dpfw/user_dpfw_detial",
						component: user_dpfw_detial,
						meta: {
							title: "点评服务",//点评服务详情
							is_login:true,
		
						},
					},
					{
						path: "/user_dpfw/user_dpfw_add",
						name: "user_dpfw/user_dpfw_add",
						component: user_dpfw_add,
						meta: {
							title: "点评服务",//点评服务 立即点评
							is_login:true,
		
						},
					},

					
					{
						path: "/user_wtfw",
						name: "user_wtfw",
						component: user_wtfw,
						meta: {
							title: "委托服务",//委托服务列表
							is_login:true,
		
						},
					},


					{
						path: "/user_wtfw/user_wtfw_detial",
						name: "user_wtfw/user_wtfw_detial",
						component: user_wtfw_detial,
						meta: {
							title: "委托服务",//委托服务详情
							is_login:true,
		
						},
					},





					
					{
						path: "/user_xx",
						name: "user_xx",
						component: user_xx,
						meta: {
							title: "我的消息",
							is_login:true,
		
						},
					},
					{
						path: "/user_zx",
						name: "user_zx",
						component: user_zx,
						meta: {
							title: "我的咨询",
							is_login:true,
		
						},
					},
					{
						path: "/user_zx/user_zx_detial",
						name: "user_zx/user_zx_detial",
						component: user_zx_detial,
						meta: {
							title: "我的咨询",//详情
							is_login:true,
		
						},
					},


					
					{
						path: "/user_jf",
						name: "user_jf",
						component: user_jf,
						meta: {
							title: "我的积分",
							is_login:true,
		
						},
					},
					{
						path: "/user_jfsc",
						name: "user_jfsc",
						component: user_jfsc,
						meta: {
							title: "积分商城",
							is_login:true,
		
						},
					},
					{
						path: "/user_jl",
						name: "user_jl",
						component: user_jl,
						meta: {
							title: "我的奖励",
							is_login:true,
		
						},
					},
					{
						path: "/user_jl/family_list",
						name: "user_jl/family_list",
						component: family_list,
						meta: {
							title: "我的家人",
							is_login:true,
		
						},
					},
					{
						path: "/user_jl/share",
						name: "user_jl/share",
						component: share,
						meta: {
							title: "我的分享大使",
							is_login:true,
		
						},
					},
					{
						path: "/user_jl/payouts",
						name: "user_jl/payouts",
						component: payouts,
						meta: {
							title: "提现",
							is_login:true,
		
						},
					},
					
					
					{
						path: "/user_cwgl",
						name: "user_cwgl",
						component: user_cwgl,
						meta: {
							title: "财务管理",
							is_login:true,
		
						},
					},


					
					{
						path: "/user_zl",
						name: "user_zl",
						component: user_zl,
						meta: {
							title: "个人资料",
							is_login:true,
		
						},
					},
					{
						path: "/user_mm",
						name: "user_mm",
						component: user_mm,
						meta: {
							title: "修改密码",
							is_login:true,
		
						},
					},
					{
						path: "/user_gl",
						name: "user_gl",
						component: user_gl,
						meta: {
							title: "发票管理",
							is_login:true,
		
						},
					},
					{
						path: "/user_gl/user_gl_detial",
						name: "user_gl/user_gl_detial",
						component: user_gl_detial,
						meta: {
							title: "发票管理",//详情
							is_login:true,
		
						},
					},

					
					
				],
			},
			{
				path: "/user_bzzx",
				name: "user_bzzx",
				component: user_bzzx,
				meta: {
					title: "帮助中心",
					is_login:true,

				},
			},
			
			
		]
	},
// 
	{
		path: "/agreement",
		name: "agreement",
		component: agreement,
		meta: {
			title: "协议页面",
			keepAlive: false,
		},
	},
	{
		path: "*",
		redirect: "/",
	},
];

const scrollBehavior = (to, from, savedPosition) => {
	// console.log('滚动行为', to, from, savedPosition)
	if (savedPosition) {
		return savedPosition;
	} else {
		return {
			x: 0,
			y: 0
		};
	}
};
const router = new VueRouter({
	routes,
	base: "/",
	// mode: "hash",
	mode: "history",
	scrollBehavior,
});

router.beforeEach((to, from, next) => {
	// debugger
	// console.log("路由导航守卫 to", to);
	// console.log("路由导航守卫 from", from);
	if (to.meta.title) {
		/* 路由发生变化修改页面title */
		// document.title = to.meta.title;
	}

	// debugger

	// 会话策略：标签页关闭后失效，连续 30 分钟无操作后失效。
	const SESSION_KEY = "session_active";
	const LAST_ACTIVITY_KEY = "last_activity_time";
	const SESSION_TIMEOUT = 30 * 60 * 1000;
	const token = localStorage.getItem("token");
	const now = Date.now();
	const isLoginPage = ["login", "enroll", "password", "login_info", "login_info_end"].includes(to.name);

	if (token && !isLoginPage) {
		const sessionActive = sessionStorage.getItem(SESSION_KEY) === "1";
		const lastActivity = Number(localStorage.getItem(LAST_ACTIVITY_KEY) || 0);
		if (!sessionActive || !lastActivity || now - lastActivity >= SESSION_TIMEOUT) {
			localStorage.removeItem("token");
			localStorage.removeItem(LAST_ACTIVITY_KEY);
			sessionStorage.removeItem(SESSION_KEY);
			next({ path: "/login", query: { expired: "1" } });
			return;
		}
		localStorage.setItem(LAST_ACTIVITY_KEY, String(now));
	}
	if (to.name === "login" && sessionStorage.getItem(SESSION_KEY) !== "1") {
		localStorage.removeItem("token");
		localStorage.removeItem(LAST_ACTIVITY_KEY);
	}
	console.log('to', to)
	next()

	// let token = localStorage.getItem("token") || ''

	// if(to.meta.is_login){
	// 	if (token) {
	// 		next()
	// 		return
	// 	} else {
	// 		next('/')
	// 		// next({ ...to, replace: true })
	// 		return
	// 	}
	// }else{
	// 	next()
	// }



	// 兼容IE

	// next(); 
	// debugger
	// if (to.name == "login") {
	//   next();

	// } else if (token) {
	//   next()
	// }else{
	//   next('/')
	// }
});

// router.beforeResolve((to, from, next) => {
//   console.log("beforeResolve 路由守卫", to);
//   console.log("beforeResolve 路由守卫", from);

//   if (from.query && from.query.role) {
//     if (!to.query || !to.query.role) {
//       to.query.role = from.query.role;
//     }
//   }

//   next()
// });

router.afterEach((to, from) => {
	document.querySelector('#app').scrollTop =0;

	// console.log("************** afterEach **************", to, from);
	// let is_need_user_full_info = false;
	// let need_user_full_info_routes = ["formsCompanyView", "formsCompanyInfo", "formsCompanyEmployee", "formsQuarterlyList", "formsQuarterlyInfo", "formsAnnualList", "formsAnnualCompanyQualification", "formsAnnualFinancial", "formsAnnualIntellectualProperty", "formsAnnualProjectList", "formsAnnualProjectApproval", "formsAnnualProjectPayment", "formsAnnualProjectResearch", "serviceCar", "serviceClear", "serviceRepair", "serviceMeetingRoom"];
	// // debugger
	// if (need_user_full_info_routes.includes(to.name)) {
	//   is_need_user_full_info = true;
	// }
	// // debugger
	// //是否需要用户补全资料后填写  当前用户是否已经补全资料
	// let baseInfo = {};
	// if (localStorage.getItem("baseInfo")) {
	//   baseInfo = JSON.parse(localStorage.getItem("baseInfo")) || {};
	// }
	// //用户资料审核通过 info_state == 3
	// // && baseInfo.info_state != 3
	// if (is_need_user_full_info) {
	//   if (localStorage.getItem("token")) {
	//     store.dispatch("router_getUserInfo");
	//   }
	//   // console.log("需要用户补全资料 并且用户未补全资料");
	//   // store.commit("pop_info_tip_time");
	//   // next();
	// } else {
	//   // next();
	// }


});

export default router;
